import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteMaintenanceStatusSaga,
  getMaintenanceStatusDetailsSaga,
  getMaintenanceStatusListSaga,
} from "src/store/maintenance-status/saga";
import {
  MaintenanceStatusDetailDto,
  MaintenanceStatusDto,
} from "src/store/maintenance-status/type";
import MaintenanceStatusCreateForm from "./create";
import MaintenanceStatusEditForm from "./edit";
const MaintenanceStatusPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState<MaintenanceStatusDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<MaintenanceStatusDetailDto>();
  const columns = [
    {
      text: t("MaintenanceStatus.Name"),
      dataField: "Name",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("MaintenanceStatus.PageTitle")}
        metaTag={t("MaintenanceStatus.MetaTag")}
        gridProps={{
          addTitle: t("MaintenanceStatus.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getMaintenanceStatusListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getMaintenanceStatusDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: MaintenanceStatusDto) =>
              t("MaintenanceStatus.DeleteQA", {
                name: data.Name,
              }),
            action: deleteMaintenanceStatusSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <MaintenanceStatusCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getMaintenanceStatusListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <MaintenanceStatusEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getMaintenanceStatusListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default MaintenanceStatusPage;
